<app-topnav></app-topnav>
<div class="video-store-login-legacy">
  <div class="h-30"></div>
  <div class="container">
    <div class="content">
      <div class="video-store-login-content">
        <div class="video-store-login-image">
          <img src="assets/splash_bilingual.png" class="main-banner" alt="">
          <div class="mb-10"></div>
          <div class="bb-video-intro-bilingual">
            <span class="intro">
              <img src="assets/BounceBack-EN2.png" alt="BounceBack">
              <span>Life can get on top of us all at times due to work related issues, family worries, sleep difficulties or physical health problems.
                BounceBack® aims to be an empowering and practical way of learning key life skills that can boost your mood and help you turn the corner.
                BounceBack® uses resources based on the proven cognitive behavioural therapy (CBT) approach.
              </span>
            </span>
            <span class="intro">
              <img src="assets/BounceBack-FR3.png" alt="Retrouver son entrain">
              <span>
                La vie peut parfois être ardue en raison de problèmes liés au travail, de soucis familiaux, de difficultés de sommeil ou de problèmes de santé physique.
                Retrouver son entrain est un moyen efficace et pratique d'acquérir des compétences essentielles qui peuvent améliorer votre humeur et vous aider à
                remonter la pente. Retrouver son entrain est basé sur l'approche éprouvée de la thérapie cognitivo-comportementale (TCC).
              </span>
            </span>
          </div>
          <div class="h-30"></div>
          <div class="intro-cmha-logo">
            <div class="logo-batch">
              <img src="assets/CMHABC.jpg" alt="CMHA BC">
            </div>

            <div class="h-30"></div>
            <div class="logo-batch">
              <img src="assets/CMHA-MBWPG.png" class="other-logos" alt="">
              <img src="assets/CMHA_ON.png" class="other-logos" alt="">
            </div>

            <div class="h-30"></div>
            <div class="logo-batch">
              <img src="assets/IERHA.gif" class="other-logos" alt="">
              <img src="assets/ON_POS_LOGO_RGB.png" class="other-logos" alt="">
            </div>

            <div class="h-30"></div>
            <div class="logo-batch">
              <img src="assets/WRHA.gif" class="other-logos" alt="">
              <img src="assets/ACSM FR.png" class="other-logos" alt="">
            </div>
          </div>
        </div>
        <div class="video-store-login-form">

          <div class="panel-heading" [hidden]="!showLoginForm">
            {{'signInHereText'|translate:translation }}
          </div>
          <div class="panel-heading" [hidden]="showLoginForm">
            {{'alreadyLoggedInText'|translate:translation}}
          </div>
          <div class="panel-body" [hidden]="!showLoginForm">
            <label for="email-legacy">{{'emailIdLoginFormText'|translate:translation}}</label>
            <input type="email" id="email-legacy" name="email" class="form-control" [(ngModel)]="loginModel.email" placeholder="example@email.com" required="">
            <label for="token-legacy">{{'loginCodeText'|translate:translation}}</label>
            <input type="password" id="token-legacy" name="token" class="form-control" [(ngModel)]="loginModel.provinceCode" placeholder="ABC-123" required="">
            <br>
            <button type="button" class="btn btn-sm video-store-login-button" (click)="loginWithProvinceCode()">{{'signinText'|translate:translation}}</button>
          </div>

          <div class="panel-body" [hidden]="showLoginForm">
            <label>{{'loggedInAsText'|translate:translation}}: {{this.username}}</label>
          </div>

          <div class="video-store-login-error" [class.hide]="!showError">
            Invalid login credentials
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
